// libraries
import type { RollbackState, StateTree } from '@makemydeal/dr-dash-types';

export const getRollbackState = (state: StateTree): RollbackState => {
    return (state.rollback as RollbackState) || ({} as RollbackState);
};
